import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';
import { Article, Author } from '../../../models/article';

import inarticleRecirculationStyles from './InarticleRecirculation_styles';

export interface InarticleRecirculationProps {
  article: Article;
  label?: string;
  author?: Author;
  onClick?: () => any;
}

const InarticleRecirculation = ({
  onClick,
  label,
  article: { link, title, author },
  styles,
}: InarticleRecirculationProps &
  StylesProps<typeof inarticleRecirculationStyles>) => (
  <a href={link} title={title} className={styles.link} onClick={onClick}>
    <div className={styles.container}>
      <Spacer row>
        <Spacer space={'xxs'} align={'stretch'}>
          {label && <div className={styles.label}>{label}</div>}

          <div className={cx(styles.title, 'InarticleRecirculation__title')}>
            {title}
          </div>
          <div className={styles.byline}>
            by <span className={styles.bylineAuthor}>{author.name}</span>
          </div>
        </Spacer>
      </Spacer>
    </div>
  </a>
);

export default styled(inarticleRecirculationStyles)(InarticleRecirculation);
